import { render, staticRenderFns } from "./windowContent.vue?vue&type=template&id=688ab6cd&scoped=true"
import script from "./windowContent.vue?vue&type=script&lang=js"
export * from "./windowContent.vue?vue&type=script&lang=js"
import style0 from "./windowContent.vue?vue&type=style&index=0&id=688ab6cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688ab6cd",
  null
  
)

export default component.exports